import React from 'react';
import Header from './Header';
import SummaryCards from './SummaryCards';
import Charts from './Charts';
import Insights from './Insights';
import TransactionsList from './TransactionsList';
import Footer from './Footer';
import { useToast } from './Toast';

function Dashboard({ dark, setDark }) {
  const [showToast, ToastEl] = useToast();

  return (
    <>
      <Header dark={dark} setDark={setDark} />
      <main className="main-content">
        <SummaryCards />
        <Charts />
        <Insights />
        <TransactionsList onToast={showToast} />
      </main>
      <Footer />
      {ToastEl}
    </>
  );
}

export default Dashboard;
